import { createAction } from 'redux-actions';
import api from '../../services/api';
import {
  SAVE_ARTICLE,
  SAVE_ARTICLE_SUCCESS,
  SAVE_ARTICLE_FAILURE,
  ADD_ARTICLE_TO_THE_LIST,
  UPDATE_ARTICLE_IN_THE_LIST
} from './actionTypes';
import { change } from 'redux-form';

//<<<---SAVE-ARTICLE--->>>
export const saveArticleInProgress = createAction(SAVE_ARTICLE);
export const saveArticleSuccess = createAction(SAVE_ARTICLE_SUCCESS);
export const addArticleToTheList = createAction(ADD_ARTICLE_TO_THE_LIST);
export const saveArticleFailure = createAction(SAVE_ARTICLE_FAILURE);

export const saveArticle = (formData, lang, callback) => async dispatch => {
  dispatch(saveArticleInProgress());
  try {
    const res = await api.post(`article/${lang}`, formData);
    const { data } = res;
    callback();
    dispatch(saveArticleSuccess(data));
    dispatch(addArticleToTheList(data));
  } catch (error) {
    dispatch(saveArticleFailure(error));
  }
};

//<<<---UPDATE-ARTICLE--->>>
export const updateArticleInTheList = createAction(UPDATE_ARTICLE_IN_THE_LIST);

export const updateArticle = (
  formData,
  id,
  lang,
  callback
) => async dispatch => {
  dispatch(saveArticleInProgress());
  try {
    const res = await api.post(`article/${id}/${lang}`, formData, {
      headers: { 'X-HTTP-Method-Override': 'PUT' }
    });
    const { data } = res;
    callback();
    dispatch(saveArticleSuccess(data));
    dispatch(updateArticleInTheList(data));
  } catch (error) {
    dispatch(saveArticleFailure(error));
  }
};

export const setValueToEmptyObject = (formName, fieldName) => () =>
  change(formName, fieldName, {});



// WEBPACK FOOTER //
// ./src/modules/ArticleForm/actions.js